export const profilePath = (user) => {
  if (!user) return '/';
  return `/user/${user._id || user.id}`;
};
